import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Text,
  TableCell,
} from "grommet";

export class RouteInstanceTables extends Component {
  state = {
    tableRows: [],
  };

  getPrettyDateString = (dateString) => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  getTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);

    let differenceString = difference.toISOString().substr(11, 8);
    const diffArray = differenceString.split(":");
    if (diffArray[0] === "00") {
      differenceString = diffArray[1] + ":" + diffArray[2];
    }
    return differenceString;
  };

  getStringFromSeconds = (timeTaken) => {
    const hours = Math.floor(timeTaken / 3600);
    timeTaken %= 3600;
    const minutes = Math.floor(timeTaken / 60);
    const seconds = timeTaken % 60;

    let minuteString;
    let secondString;
    let hoursString;

    if (hours < 10) {
      hoursString = "0" + hours;
    } else {
      hoursString = "" + hours;
    }

    if (minutes < 10) {
      minuteString = "0" + minutes;
    } else {
      minuteString = "" + minutes;
    }

    if (seconds < 10) {
      secondString = "0" + seconds;
    } else {
      secondString = "" + seconds;
    }
    const secondStringArray = secondString.split(".");

    const timeString =
      hoursString + ":" + minuteString + ":" + secondStringArray[0];
    return timeString;
  };

  calculateTimeTaken = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);
    return difference / 1000;
  };

  getIdealTime = (distance) => {
    if (typeof distance === "number") {
      const firstCalc = (20 + distance) / 0.55;
      return firstCalc;
    } else {
      return 300;
    }
  };

  updateTableRows = (shiftGuards) => {
    let tableRows = [];

    shiftGuards.forEach((shiftGuard) => {
      const roleInstances = shiftGuard.RoleInstances;
      if (typeof roleInstances == "object") {
        roleInstances.forEach((roleInstance) => {
          const role = roleInstance.Role;

          let tableRowElement;
          if (
            role.Type === "Patrol" &&
            typeof roleInstance.RouteInstances == "object"
          ) {
            roleInstance.RouteInstances.forEach((routeInstance) => {
              // use the color spectrum on the heat map to come up with the scale for the words.
              const start = new Date(routeInstance.StartTimeDate);
              const end = new Date(routeInstance.EndTimeDate);
              if (start < end) {
                let idealTime = routeInstance.distance;
                if (routeInstance.distance === null) {
                  idealTime = 300;
                }

                let DateTimeStart;
                let timesValid = true;
                if (typeof routeInstance.StartTimeDate === "string") {
                  DateTimeStart = this.getPrettyDateString(
                    routeInstance.StartTimeDate
                  );
                } else {
                  DateTimeStart = "N/A";
                  timesValid = false;
                }

                let DateTimeEnd;
                if (typeof routeInstance.EndTimeDate === "string") {
                  DateTimeEnd = this.getPrettyDateString(
                    routeInstance.EndTimeDate
                  );
                } else {
                  DateTimeEnd = "N/A";
                  timesValid = false;
                }
                let isOnTimeState = "True";
                if (timesValid) {
                  const timeTaken = this.calculateTimeTaken(
                    routeInstance.StartTimeDate,
                    routeInstance.EndTimeDate
                  );
                  if (timeTaken <= idealTime) {
                    isOnTimeState = "True";
                  } else {
                    isOnTimeState = "False";
                  }
                }

                let timeDifference;
                if (DateTimeEnd !== "N/A" && DateTimeStart !== "N/A") {
                  timeDifference = this.getTimeDifference(
                    routeInstance.StartTimeDate,
                    routeInstance.EndTimeDate
                  );
                } else {
                  timeDifference = "N/A";
                }

                tableRowElement = {
                  guardName: shiftGuard.Gaurd.GaurdFirstName,
                  timeTaken: timeDifference,

                  isOnTime: "" + routeInstance.isOnTime,
                  idealTime: this.getStringFromSeconds(idealTime),
                  route:
                    routeInstance.Route.pOIByStartpointid.Description +
                    " to " +
                    routeInstance.Route.POI.Description,
                  startTimeDate: DateTimeStart,
                  endTimeDate: DateTimeEnd,

                  //patrolPointsReached: element.PatrolPointsReached
                };
                tableRows.push(tableRowElement);
              }
            });
          }
        });
      }
    });
    const newState = {
      ...this.state,
      tableRows: tableRows,
    };
    this.setState(newState);
  };

  componentDidMount = () => {
    this.updateTableRows(this.props.shiftData.Shift_Gaurds);
  };
  render() {
    var guardnamecolour = "lol";

    const tableRows = this.state.tableRows;
    return (
      <Box>
        <Table>
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Guard Name
              </TableCell>
              <TableCell scope="col" border="bottom">
                On Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Time Taken
              </TableCell>
              <TableCell scope="col" border="bottom">
                Ideal Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Route
              </TableCell>
              <TableCell scope="col" border="bottom">
                Start Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                End Time
              </TableCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {tableRows.map((tableRow, index) => {
              return (
                <TableRow key={index}>
                  <TableCell scope="row">
                    <Text
                      style={{
                        color:
                          guardnamecolour === "red"
                            ? "red"
                            : guardnamecolour === "green"
                            ? "green"
                            : guardnamecolour === "green"
                            ? "yellow"
                            : guardnamecolour === "blue"
                            ? "blue"
                            : "black",
                      }}
                    >
                      {tableRow.guardName}
                    </Text>
                  </TableCell>
                  <TableCell>
                    <Text
                      style={{
                        color: tableRow.isOnTime === "true" ? "green" : "red",
                      }}
                    >
                      {tableRow.isOnTime}
                    </Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.timeTaken}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.idealTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.route}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.startTimeDate}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.endTimeDate}</Text>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default RouteInstanceTables;
